import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	register(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `registration`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	registerRequest(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `registration/request`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}
}
